module.exports = __webpack_public_path__ + "media/images/samples/1280x768/9-927c70b3d0aa46c86a090a346ca2c985.jpg";